import { createFileRoute } from "@tanstack/react-router";
import { QueueForm } from "./-component/queue-form";
import { usePermissionRedirect } from "@/hooks/use-permission-redirect";

export const Route = createFileRoute("/_dashboard/queues/new-queue")({
  component: NewQueueComponent,
  loader: async ({ context }) => ({
    crumb: "New queue",
    user: (context as any).user,
  }),
});

function NewQueueComponent() {
  const { user } = Route.useLoaderData();
  usePermissionRedirect({
    user,
    permission: "QUEUE",
    checkType: "write",
    toastMessage: "You don't have permission to create queues.",
    redirectTo: "/queues",
  });
  return <QueueForm isEdit={false} queue={null} />;
}
